<!--
报警记录表格
-->
<template>
  <div class="warning_tab" v-if="isShow">
  <!-- <div class="warning_tab" v-if="true"> -->
    <img src="@/assets/img/stat_border.png" />
    <div class="stat_top">
      <ContentSection :title="'报警记录'" :mainStyle="{ display: 'none' }" />
      <div class="close" @click="cancel">
        <img src="@/assets/img/dialog_close.png" />
      </div>
    </div>
    <!-- 搜索赛选 -->
    <div class="search">
      <div class="search_name">
        设备名称
        <input class="text_input" type="text" v-model="searchData.equipmentname" />
      </div>
      <div class="search_state" tabindex="-1" @blur="setSelectShow(false)">
        状态
        <div class="text_input" @click="setSelectShow">
          {{ searchData.state.label }}
        </div>
        <ul v-if="selectShow">
          <li
            v-for="item in selectList"
            :key="item.value"
            @click="changeSearchState(item)"
          >
            {{ item.label }}
          </li>
        </ul>
      </div>
      <div @click="setDateInputFocus('dateInput1')">
        开始时间
        <el-date-picker
          v-model="searchData.startTime"
          type="date"
          placeholder="选择日期"
          ref="dateInput1"
        >
          <i slot="suffix" class="el-input__icon"></i>
        </el-date-picker>
      </div>
      <div @click="setDateInputFocus('dateInput2')">
        结束时间
        <el-date-picker
          v-model="searchData.endTime"
          type="date"
          placeholder="选择日期"
          ref="dateInput2"
          
        >
        </el-date-picker>
      </div>
      <div class="search_box" @click="search">
        <img src="@/assets/img/warning_search_icon.png" />
        <span>搜索</span>
      </div>
    </div>

    <!-- 翻页 -->
    <div class="page_box">
      <div class="change_page">
        <!-- 当前页码 -->
        <span>当前第{{ page }}页</span>
        <!-- 上一页 -->
        <div class="page_btn" @click="changePage(-1)">上一页</div>
        <!-- 上一页 -->
        <div class="page_btn" @click="changePage(1)">下一页</div>
        <!-- 总条数 -->
        <span>总{{ tableTotal }}条</span>
      </div>
    </div>

    <!-- 内容部分 -->
    <div class="content">
      <ul class="table_top">
        <li class="order_num"><span>序号</span></li>
        <li class="dev_name"><span>设备名称</span></li>
        <li class="par_name"><span>参数名称</span></li>
        <li class="war_content"><span>报警内容</span></li>
        <li class="war_value"><span>报警值</span></li>
        <li class="war_time"><span>报警时间</span></li>
        <li class="pro_time"><span>处理时间</span></li>
        <li class="pro_remarks"><span>处理说明</span></li>
        <li class="state"><span>状态</span></li>
        <li class="oper"><span>操作</span></li>
      </ul>
      <ul class="table_content">
        <li v-for="(item, index) in tableData" :key="index">
          <span class="order_num">{{ index + 1 }}</span>
          <span class="dev_name">{{
            tableData[(page - 1) * 10 + index].equipmentname
          }}</span>
          <span class="par_name">{{
            tableData[(page - 1) * 10 + index].parName
          }}</span>
          <span class="war_content">{{
            tableData[(page - 1) * 10 + index].alarmtext
          }}</span>
          <span class="war_value">{{
            tableData[(page - 1) * 10 + index].alarmvalue
          }}</span>
          <span class="war_time">{{
            tableData[(page - 1) * 10 + index].alarmbegintime
          }}</span>
          <span class="pro_time">{{
            tableData[(page - 1) * 10 + index].proTime
          }}</span>
          <span class="pro_remarks">{{
            tableData[(page - 1) * 10 + index].proRemarks
          }}</span>
          <span
            class="state"
            style="color: #ffd200"
            v-if="tableData[(page - 1) * 10 + index].status == 1"
            >未处理</span
          >
          <span class="state" style="color: #038efa" v-else>已处理</span>
          <span class="oper">
            <div
              v-if="tableData[(page - 1) * 10 + index].state == 0"
              class="oper_btn"
              style="background: rgba(3, 142, 250, 0.5)"
              @click="handleOper($event, index)"
            >
              处理
            </div>
            <div
              v-else
              class="oper_btn"
              style="background: rgba(255, 255, 255, 0.2)"
              @click="handleOper($event, index)"
            >
              处理
            </div>
          </span>
        </li>
      </ul>
    </div>
    <!-- 报警详情弹框 -->
    <div class="warning_dialog" v-show="dialogShow">
      <div>
        <div class="dialog_top">
          <span>报警详情</span>
          <div class="close" @click="cancelDia">
            <img src="@/assets/img/dialog_close.png" />
          </div>
        </div>
        <ul class="dialog_main">
          <li>
            <span>设备名称:</span><span>{{ warningInfo.devName }}</span>
          </li>
          <li>
            <span>参数名称:</span><span>{{ warningInfo.parName }}</span>
          </li>
          <li>
            <span>状态:</span>
            <span style="color: #ffd200" v-if="warningInfo.state == 0"
              >未处理</span
            >
            <span style="color: #038efa" v-else>已处理</span>
          </li>
          <li>
            <span>时间:</span><span>{{ warningInfo.warTime }}</span>
          </li>
          <li>
            <span>内容:</span><span>{{ warningInfo.warContent }}</span>
          </li>
          <li>
            <span>处理结果:</span
            ><input type="text" v-model="warningInfo.pro" />
          </li>
          <li>
            <span>处理备注:</span
            ><input type="text" v-model="warningInfo.proRemarks" />
          </li>

          <div class="btn_box">
            <div>报警处理</div>
            <div>忽略</div>
          </div>
        </ul>
        <!-- 弹框底部装饰 -->
        <img class="dialog_bottom" src="@/assets/img/mms3d_dialog_bottom.png" />
      </div>
    </div>
  </div>
</template>

<script>
import ContentSection from "@/components/ContentSection";
import {getAlarm} from "@/api/basic.js"

export default {
  name: "statAna",
  components: {
    ContentSection,
  },
  data() {
    return {
      isShow: false,
      // 表格的数据
      tableData: [],
      // 控制报警详情弹框显示
      dialogShow: false,
      // 报警详情数据
      warningInfo: {},
      // 搜索的数据
      searchData: {
        equipmentname: "",
        state: {
          value: '',
          label: "请选择",
        },
        startTime: "",
        endTime: "",
      },
      // 下拉框数据
      selectList: [
        {
          value: 0,
          label: "未处理",
        },
        {
          value: 1,
          label: "已处理",
        },
      ],
      // 控制下拉框显示
      selectShow: false,
      // 日期组件图标
      dateInputIcon: require("@/assets/img/warning_search_time.png"),
      // 数据总数
      tableTotal: 0,
      // 当前页码
      page: 1,
      // 每页数据渲染条数
      tableDataNum: 10,
    };
  },
  created() {},
  mounted() {
    let date = new Date()
    this.searchData.startTime =date
    this.searchData.endTime = date
    // this.search();
  },
  beforeDestroy() {},
  methods: {
    // 关闭弹框
    cancel() {
      this.isShow = false;
      this.dialogShow = false;
    },
    // 打开弹框
    openThis() {
      this.isShow = true;
      this.search()
    },
    // 关闭报警详情弹框
    cancelDia() {
      this.dialogShow = false;
    },
    // 获取表格数据方法
    search() {
      this.tableData = []
      console.log(this.searchData)
      let data = {
        equipmentname:'',
        equipmentname:this.searchData.equipmentname,
        status: this.searchData.state.value,
        starttime: this.$formatDate(this.searchData.startTime).year + ' ' +"00:00:00",
        endtime:this.$formatDate(this.searchData.endTime).year + ' ' +this.$formatDate(this.searchData.endTime).hours
      }
      // getAlarm(data).then(res=>{
      //   if(res.errorcode == 0){
      //     console.log(res)
      //     this.tableData = [...res.resultdata.rows]
      //   }
      // })
      let obj = {
        equipmentname: "2_04立式水翼搅拌机",
        parName: "水位",
        alarmtext: "水位过高请及时处理",
        alarmvalue: "234mm",
        alarmbegintime: "09:00:00/2022-07-23",
        proTime: "09:00:00/2022-07-23",
        proRemarks: "",
        state: "0",
        proRemarks:'无'
      };
      for (let i = 0; i < 15; i++) {
        if(i%2==0){
          obj.equipmentname= '事故池液位'
          obj.parName= '液位'
          obj.alarmvalue= '300cm'
        }else{
          obj.equipmentname= '出水流量计'
          obj.parName= '流量'
          obj.alarmvalue= '10m3/m'
        }
        this.tableData.push({ ...obj });
      }
      this.tableData[0].state = 1;
      this.tableTotal = this.tableData.length;
    },

    // 点击表格中处理按钮触发
    handleOper(e, index) {
      // let diaDom = document.querySelector(".warning_dialog");
      // e.target.appendChild(diaDom);
      this.warningInfo = { ...this.tableData[index] };
      // this.dialogShow = true;
    },

    // 修改搜索框中状态选择
    changeSearchState(val) {
      this.searchData.state = { ...val };
    },

    // 控制下拉框展示
    setSelectShow() {
      this.selectShow = !this.selectShow;
    },

    // 日期组件获取焦点
    setDateInputFocus(val) {
      this.$refs[val].focus();
    },

    // 翻页方法
    changePage(val) {
      // 判断如果为第一页则上一页不可用，最后一页则下一页不可用
      if (
        (this.page == 1 && val == -1) ||
        (this.page == Math.ceil(this.tableData.length / 10) && val == 1)
      ) {
        return;
      }
      this.page += val;
      this.tableDataNum = 10;
      // 判断是否到最后一页如果是，修改渲染的条数
      if (
        this.page == Math.ceil(this.tableData.length / 10) &&
        this.tableData.length % 10 !== 0
      ) {
        this.tableDataNum = this.tableData.length % 10;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.warning_tab {
  position: fixed;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 20, 46, 0.7);
  width: 3900px;
  height: 2252vh * @vh;
  border-bottom-right-radius: 50px;
  // 边框图片
  & > img {
    width: 3900px;
    height: 2253vh * @vh;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
  // 顶部标题和关闭按钮样式
  .stat_top {
    width: 3700px;
    margin: auto;
    margin-top: 70vh * @vh;
    margin-bottom: 155vh * @vh;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  // 关闭按钮
  .close {
    width: 38px;
    height: 38px;
    background: #012c64;
    border: 1vw * @vw solid #038efa;
    display: flex;
    cursor: pointer;
    position: relative;
    z-index: 1;
    & > img {
      width: 13px;
      margin: auto;
    }
  }
  // 搜索部分样式
  .search {
    display: flex;
    justify-content: space-around;
    font-size: 36px;
    color: #fff;
    input {
      outline: none;
      background: rgba(0, 0, 0, 0.4);
      color: #fff;
      border: none;
      font-size: 36px;
    }
    .text_input {
      width: 573px;
      border: 1vw * @vw solid rgba(255, 255, 255, 0.6);
      background: rgba(0, 0, 0, 0.4);
      height: 60vh * @vh;
    }
    // 状态
    .search_state {
      width: 413px;
      position: relative;
      outline: none;
      .text_input {
        width: 318px;
        text-align: center;
        float: right;
      }
      &::after {
        content: "";
        display: block;
        width: 29px;
        height: 19vh * @vh;
        background-image: url("@/assets/img/warning_search_state.png");
        background-size: 100% 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 45px;
      }
      & > ul {
        position: absolute;
        width: 318px;
        right: 0;
        border: 1vw * @vw solid rgba(255, 255, 255, 0.6);
        background: rgba(0, 0, 0, 0.4);
        li:hover {
          background: rgba(255, 255, 255, 0.6);
        }
      }
    }
    .el-date-editor {
      background: rgba(0, 0, 0, 0.4);
      border-radius: 0;
      height: 60vh * @vh;
      width: 440px;
      position: relative;
      &::after {
        content: "";
        display: block;
        width: 34px;
        height: 34px;
        background-image: url("@/assets/img/warning_search_time.png");
        background-size: 100% 100%;
        position: absolute;
        top: 20%;
        right: 60px;
      }
      ::v-deep .el-input__inner {
        background: none;
        border: none;
      }
      ::v-deep .el-input__prefix {
        display: none;
      }
    }
    .search_box {
      width: 200px;
      height: 80vh * @vh;
      display: flex;
      align-items: center;
      background: #038efa;
      cursor: pointer;
      border-radius: 5vw * @vw;
      img {
        width: 40px;
        margin-right: 20px;
        margin-left: 20px;
      }
    }
  }

  // 分页组件样式
  .page_box {
    width: 100%;
    margin: 80vh * @vh 0;
    // position: relative;
    overflow: hidden;
  }
  .change_page {
    color: #fff;
    width: 810px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    float: right;
    font-size: 26px;
    margin-right: 140px;
    // 翻页按钮
    .page_btn {
      width: 184px;
      height: 56vh * @vh;
      background: rgba(1, 44, 100, 0.5);
      line-height: 56vh * @vh;
      cursor: pointer;
      position: relative;
      &::after {
        content: "";
        display: block;
        width: 19px;
        height: 19px;
        background-image: url("@/assets/img/dialog_sanjiao.png");
        background-size: 100% 100%;
        position: absolute;
        right: 0;
        bottom: 0;
        transform: rotate(-90deg);
      }
    }
  }
  // 内容部分样式
  .content {
    width: 100%;
    box-sizing: border-box;
    padding: 0 100px;
    font-size: 40px;
    color: #fff;
    // 设置每一列的宽度
    // 序号
    .order_num {
      width: 191px;
    }
    // 设备名称
    .dev_name {
      width: 465px;
    }
    // 参数名称
    .par_name {
      width: 291px;
    }
    // 报警内容
    .war_content {
      width: 529px;
    }
    // 报警值
    .war_value {
      width: 325px;
    }
    // 报警时间
    .war_time {
      width: 585px;
    }
    // 处理时间
    .pro_time {
      width: 570px;
    }
    // 处理说明
    .pro_remarks {
      width: 631px;
    }
    // 状态
    .state {
      width: 291px;
    }
    // 操作
    .oper {
      width: 433px;
      & > span {
        float: right;
        margin-right: 80px;
      }
    }
    .table_top {
      display: flex;
      background: linear-gradient(
        to right,
        rgba(3, 142, 250, 1),
        rgba(1, 44, 100, 1)
      );
      height: 114vh * @vh;
      line-height: 114vh * @vh;
    }
    .table_content {
      height: 1590vh * @vh;
      overflow-y: scroll;
      // 表身滚动条样式
      &::-webkit-scrollbar {
        width: 14px;
      }
      &::-webkit-scrollbar-thumb {
        background: rgb(131, 170, 228);
      }
      & > li {
        height: 114vh * @vh;
        display: flex;
        align-items: center;
        margin: 80vh * @vh 0;
        line-height: 114vh * @vh;
        &:nth-child(2n) {
          background: linear-gradient(
            to right,
            rgba(3, 142, 250, 0.3),
            rgba(1, 44, 100, 0.3)
          );
        }
        .oper_btn {
          width: 149px;
          height: 68vh * @vh;
          line-height: 68vh * @vh;
          margin: auto;
          float: right;
          margin-right: 35px;
          cursor: pointer;
          .warning_dialog {
            & > img {
              margin-top: 90vh * @vh;
              width: 162px;
              height: 382vh * @vh;
            }
          }
        }
      }
    }
  }
  // 报警详情弹框
  .warning_dialog {
    width: 776px;
    color: #fff;
    position: absolute;
    // right: -630px;
    left: 50%;
    top: 40%;
    height: 912vh * @vh;
    display: flex;
    transform: translate(-50%, -20%);
    cursor: auto;
    .dialog_top {
      height: 93vh * @vh;
      font-size: 40px;
      background: linear-gradient(
        to right,
        rgba(3, 142, 250, 1),
        rgba(1, 44, 100, 1)
      );
      display: flex;
      align-items: center;
      & span {
        margin: auto;
        display: flex;
        align-items: center;
        &::before,
        &::after {
          content: "";
          display: block;
          width: 20px;
          height: 20px;
          background: #fff;
          border-radius: 50%;
          margin: 0 30px;
        }
      }
      & > .close {
        margin-right: 30px;
      }
    }
    // 内容部分
    .dialog_main {
      background: rgba(1, 44, 100, 1);
      box-sizing: border-box;
      padding-left: 50px;
      padding-bottom: 20vh * @vh;
      & > li {
        display: flex;
        align-items: center;
        font-size: 30px;
        text-align: left;
        margin: 10vh * @vh 0;
        span:first-child {
          width: 160px;
        }
        input {
          outline: none;
          background: rgba(0, 0, 0, 0.3);
          border: 1vw * @vw rgba(255, 255, 255, 0.6) solid;
          height: 60vh * @vh;
          width: 499px;
          color: #fff;
        }
      }
    }
    // 按钮样式
    .btn_box {
      margin: auto;
      margin-top: 55vh * @vh;
      margin-bottom: 20vh * @vh;
      width: 480px;
      display: flex;
      justify-content: space-between;
      font-size: 26px;
      & > div {
        width: 184px;
        height: 56vh * @vh;
        line-height: 56vh * @vh;
        text-align: center;
        background: rgba(3, 142, 250, 0.5);
        position: relative;
        cursor: pointer;
        &::after {
          content: "";
          display: block;
          width: 32px;
          height: 31vh * @vh;
          background-image: url("@/assets/img/dialog_sanjiao.png");
          background-size: 100% 100%;
          position: absolute;
          right: 0;
          bottom: 0;
          transform: rotate(-90deg);
        }
      }
    }
    .dialog_bottom {
      width: 100%;
      transform: translateY(-50%);
    }
  }
}
@media screen and (min-width: 3640px),screen and(max-height: 1080) {
  .warning_tab {
  // 顶部标题和关闭按钮样式
  .stat_top {
    margin-top: 30vh * @vh;
    margin-bottom: 85vh * @vh;
  }
  // 关闭按钮
  .close {
    z-index: 1;
    right:-80px;
  }
  // 搜索部分样式
  .search {
    font-size: 30px;
    input {
      font-size: 30px;
    }
    .text_input {
      height: 100vh * @vh;
    }
    .el-date-editor {
      height: 100vh * @vh;
      &::after {
        content: "";
        top: 20%;
        right: 20px;
      }
      ::v-deep .el-input__inner {
        background: none;
        border: none;
      }
      ::v-deep .el-input__prefix {
        display: none;
      }
    }
    .search_box {
      height: 110vh * @vh;
    }
  }
  // 内容部分样式
  .content {
    font-size: 32px;
    .table_content {
      height: 1550vh * @vh;
      // 表身滚动条样式
      &::-webkit-scrollbar {
        width: 12px;
      }
    }
  }
  // 报警详情弹框
  .warning_dialog {
    width: 776px;
    color: #fff;
    position: absolute;
    // right: -630px;
    left: 50%;
    top: 40%;
    height: 912vh * @vh;
    display: flex;
    transform: translate(-50%, -20%);
    cursor: auto;
    .dialog_top {
      height: 93vh * @vh;
      font-size: 40px;
      background: linear-gradient(
        to right,
        rgba(3, 142, 250, 1),
        rgba(1, 44, 100, 1)
      );
      display: flex;
      align-items: center;
      & span {
        margin: auto;
        display: flex;
        align-items: center;
        &::before,
        &::after {
          content: "";
          display: block;
          width: 20px;
          height: 20px;
          background: #fff;
          border-radius: 50%;
          margin: 0 30px;
        }
      }
      & > .close {
        margin-right: 30px;
      }
    }
    // 内容部分
    .dialog_main {
      background: rgba(1, 44, 100, 1);
      box-sizing: border-box;
      padding-left: 50px;
      padding-bottom: 20vh * @vh;
      & > li {
        display: flex;
        align-items: center;
        font-size: 30px;
        text-align: left;
        margin: 10vh * @vh 0;
        span:first-child {
          width: 160px;
        }
        input {
          outline: none;
          background: rgba(0, 0, 0, 0.3);
          border: 1vw * @vw rgba(255, 255, 255, 0.6) solid;
          height: 60vh * @vh;
          width: 499px;
          color: #fff;
        }
      }
    }
    // 按钮样式
    .btn_box {
      margin: auto;
      margin-top: 55vh * @vh;
      margin-bottom: 20vh * @vh;
      width: 480px;
      display: flex;
      justify-content: space-between;
      font-size: 26px;
      & > div {
        width: 184px;
        height: 56vh * @vh;
        line-height: 56vh * @vh;
        text-align: center;
        background: rgba(3, 142, 250, 0.5);
        position: relative;
        cursor: pointer;
        &::after {
          content: "";
          display: block;
          width: 32px;
          height: 31vh * @vh;
          background-image: url("@/assets/img/dialog_sanjiao.png");
          background-size: 100% 100%;
          position: absolute;
          right: 0;
          bottom: 0;
          transform: rotate(-90deg);
        }
      }
    }
    .dialog_bottom {
      width: 100%;
      transform: translateY(-50%);
    }
  }
}
}
</style>